module.exports = {"closeButtonText":"閉じる","thumbNailAlt":"画像をプレビュー","next":"次のページ","previous":"前のページ","addNote":"メモを追加..."}


//////////////////
// WEBPACK FOOTER
// ./translations/ja.json
// module id = 34
// module chunks = 0